var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    {
      staticClass: "box-card",
      attrs: {
        "body-style": { padding: "20px" },
        shadow: "never",
        bordered: false,
      },
    },
    [
      _c(
        "el-row",
        { attrs: { gutter: 24 } },
        [
          _c(
            "el-col",
            _vm._b({}, "el-col", _vm.grid, false),
            [
              _c(
                "el-form-item",
                { attrs: { label: "奖项名称：", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入奖项名称",
                      disabled: _vm.value.prizeType === 99 || _vm.disabled,
                    },
                    model: {
                      value: _vm.value.awardName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "awardName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.awardName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品名称：", required: "" } },
                [
                  _c("el-input", {
                    staticClass: "from-ipt-width",
                    attrs: {
                      maxlength: "100",
                      "show-word-limit": "",
                      placeholder: "请输入奖品名称",
                      disabled: _vm.value.prizeType === 99 || _vm.disabled,
                    },
                    model: {
                      value: _vm.value.prizeName,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.value,
                          "prizeName",
                          typeof $$v === "string" ? $$v.trim() : $$v
                        )
                      },
                      expression: "value.prizeName",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "奖品图片：", required: "" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "upLoadPicBox acea-row",
                      on: { click: _vm.modalPicTap },
                    },
                    [
                      _vm.value.prizePic
                        ? _c("div", { staticClass: "pictrue" }, [
                            _c("img", { attrs: { src: _vm.value.prizePic } }),
                          ])
                        : _c("div", { staticClass: "upLoad" }, [
                            _c("i", {
                              staticClass: "el-icon-camera cameraIconfont",
                            }),
                          ]),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.disabled,
                          expression: "!disabled",
                        },
                      ],
                      staticClass: "from-tips",
                    },
                    [_vm._v("建议尺寸：400*400px，上传小于500kb的图片")]
                  ),
                ]
              ),
              _vm.value.prizeType !== 99
                ? _c(
                    "el-form-item",
                    { attrs: { label: "奖品类型：", required: "" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "from-ipt-width",
                          attrs: {
                            disabled: _vm.disabled,
                            size: "small",
                            placeholder: "请选择",
                          },
                          model: {
                            value: _vm.value.prizeType,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeType", $$v)
                            },
                            expression: "value.prizeType",
                          },
                        },
                        _vm._l(_vm.prizeTypeOptions, function (item, index) {
                          return _c("el-option", {
                            key: index,
                            attrs: { label: item.label, value: item.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value.prizeType === 1
                ? _c(
                    "el-form-item",
                    { attrs: { label: "赠送积分值：", required: "" } },
                    [
                      _c("el-input-number", {
                        attrs: {
                          min: 1,
                          step: 1,
                          disabled: _vm.disabled,
                          "controls-position": "right",
                          "step-strictly": "",
                          placeholder: "请输入赠送积分值",
                        },
                        model: {
                          value: _vm.value.pointsValue,
                          callback: function ($$v) {
                            _vm.$set(_vm.value, "pointsValue", $$v)
                          },
                          expression: "value.pointsValue",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
              _vm.value.prizeType === 2
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品标题：" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品标题",
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeTitle,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeTitle",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品卖点：" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            maxlength: "100",
                            "show-word-limit": "",
                            placeholder: "请输入奖品卖点",
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.value.prizeSubTitle,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "prizeSubTitle",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.prizeSubTitle",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "赠送数量：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入数量",
                          },
                          model: {
                            value: _vm.value.prizeNum,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "prizeNum", $$v)
                            },
                            expression: "value.prizeNum",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "奖品价格：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: 0.01,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入价格",
                          },
                          model: {
                            value: _vm.value.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "price", $$v)
                            },
                            expression: "value.price",
                          },
                        }),
                        _vm._v("元 "),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "兑奖有效期：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 0,
                            step: 0.1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入时间",
                          },
                          model: {
                            value: _vm.value.validityDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "validityDate", $$v)
                            },
                            expression: "value.validityDate",
                          },
                        }),
                        _vm._v(" 小时 "),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "el-form-item",
                { attrs: { label: "中奖概率：", required: "" } },
                [
                  _c("el-input-number", {
                    attrs: {
                      min: 0,
                      step: 0.01,
                      disabled: _vm.value.prizeType === 99 || _vm.disabled,
                      "controls-position": "right",
                      controls: _vm.value.prizeType !== 99,
                      "step-strictly": "",
                      placeholder: "请输入中奖概率",
                    },
                    on: {
                      change: _vm.checkWinProbability,
                      input: _vm.checkWinProbability,
                    },
                    model: {
                      value: _vm.value.winProbability,
                      callback: function ($$v) {
                        _vm.$set(_vm.value, "winProbability", $$v)
                      },
                      expression: "value.winProbability",
                    },
                  }),
                  _vm._v(" % "),
                ],
                1
              ),
              _vm.value.prizeType !== 99
                ? [
                    _c(
                      "el-form-item",
                      { attrs: { label: "规则说明：", required: "" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            type: "textarea",
                            placeholder: "请输入规则说明",
                            autosize: { minRows: 4 },
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.value.ruleDes,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "ruleDes",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.ruleDes",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "每人中奖次数：", required: "" } },
                      [
                        _c("el-input-number", {
                          attrs: {
                            min: 1,
                            step: 1,
                            disabled: _vm.disabled,
                            "controls-position": "right",
                            "step-strictly": "",
                            placeholder: "请输入数量",
                          },
                          model: {
                            value: _vm.value.userWinLimit,
                            callback: function ($$v) {
                              _vm.$set(_vm.value, "userWinLimit", $$v)
                            },
                            expression: "value.userWinLimit",
                          },
                        }),
                        _c("div", { staticClass: "from-tips" }, [
                          _vm._v("每人最多抽中本奖项次数"),
                        ]),
                      ],
                      1
                    ),
                    _c(
                      "el-form-item",
                      { attrs: { label: "跳转链接：" } },
                      [
                        _c("el-input", {
                          staticClass: "from-ipt-width",
                          attrs: {
                            placeholder: "请输入跳转链接",
                            disabled: _vm.disabled,
                          },
                          model: {
                            value: _vm.value.redirectUrl,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.value,
                                "redirectUrl",
                                typeof $$v === "string" ? $$v.trim() : $$v
                              )
                            },
                            expression: "value.redirectUrl",
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }